import axios from 'axios'
import axiosJsonp from 'axios-jsonp'
import wx from 'wechat-js-sdk'
import md5 from 'md5'
import algo from './algo'
import Config from "./config"
import COVERAPP from "./COVERAPP"
import qs from 'qs'

let COVER = {
    //分享
    share (shareData) {
        console.log(shareData);
        if (!shareData.link) {
          shareData.link = window.location.href.split('#')[0];
        }
        if (!shareData.callback) {
          console.log(1234);
          shareData.callback = function(res) {
            console.log('share:', res);
          }
        }
        if (COVERAPP.Attribute.isApp()) {
            shareData.type = 'link'
            COVERAPP.Method.onshare(shareData);          
        } else if (COVERAPP.Attribute.isWeixin()) {
            COVER.openapi.weixin.wx_share(shareData);
        } else if (COVERAPP.Attribute.isQQ()) {
            window.setShareInfo({
                title: shareData.title,
                summary: shareData.desc,
                pic: shareData.imgUrl,
                url: shareData.link
            });
        }
    },
    // 判断是否为空
    isEmpty (obj) {
        if (obj == '' || obj == null || obj == undefined) {
            return true;
        }
        return false;
    },

    // 获取url参数值
    getUrl: function (name) {
        let fullPath = window.location.href
        if (fullPath.indexOf('?') > -1) {
            let searchData = fullPath.split('?')[1].split('&')
            let searchParams = {}
            searchData.forEach((val, i) => {
                let valData = val.split('=')
                searchParams[valData[0]] = valData[1]
            })
            return searchParams[name]
        } else {
            return ''
        }  
    },

    // 获取用户信息
    getUser (callback) {
        let _this = this;
        let userinfo = sessionStorage.getItem('COVER_USERINFO');
        if (!this.isEmpty(userinfo)) {
            callback(JSON.parse(userinfo));
        } else {
            // 如果是微信
            if (COVERAPP.Attribute.isWeixin()) {
                let code = this.getUrl('code');
                let codestate = this.getUrl('state');
                // 如果没有拿到code，则去授权登录
                if (this.isEmpty(code) || codestate.indexOf('COVER') < 0) {
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.wx_appid + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=COVER#wechat_redirect';
                    return false;
                }
                this.$request('/weixin/get', {
                    code: code
                }).then(res => {
                    if (res.errno == 0) {
                        try {
                            let info = res.data;
                            let userinfo = {
                                origin: 'wx',
                                token: info.token,
                                headimgurl: info.headimgurl,
                                nickname: info.nickname,
                                sex: info.sex
                            }
                            sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo));
                        } catch (e) {
                            console.log(e);
                        }

                        if(location.href.indexOf('#/')) {
                            window.location.href = window.location.origin + window.location.pathname + '#/' + (window.location.href.split('#/')[1] || '')
                        }
                        callback(userinfo);
                    } else {
                        callback({
                            origin: 'none'
                        });
                    }
                })
                return false;
            }

            // 支付宝登录
            if (COVERAPP.Attribute.isAlipay()) {
                let code = this.getUrl('auth_code');
                let codestate = this.getUrl('state');

                // 如果没有拿到code，则去授权登录
                if (this.isEmpty(code) || codestate.indexOf('COVER') < 0) {
                    window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2016111102735035&scope=auth_userinfo&redirect_uri=" + encodeURIComponent(window.location.href) + "&state=COVER";
                    return false;
                }
                this.ajax(Config.apiurl.aLiPayLogin, {
                    vcode: code
                }).then(data => {
                    if (data.status == 0) {
                        try {
                            let info = data.data;
                            let userinfo = {
                                origin: 'ap',
                                token: info.user_id
                            }
                            sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo));
                        } catch (e) {
                            console.log(e);
                        }

                        if(location.href.indexOf('#/')) {
                            window.location.href = window.location.origin + window.location.pathname + '#/' + (window.location.href.split('#/')[1] || '')
                        }
                        
                        callback(userinfo);
                    } else {
                        callback({
                            origin: 'none'
                        });
                    }
                });
                return false;
            }

            if (COVERAPP.Attribute.isApp()) {
                /*
                    * tips: 为了解决android客户端还未注入桥产生的诡异问题
                    * 所以不断循环监听客户端桥是否注入完成
                    * Time: 2016-07-07 PM
                    */
                let isLoad_Bridging = setInterval(function () {
                    try {
                        COVERAPP.Method.GetUser({
                            callback (ret) {
                                clearInterval(isLoad_Bridging);
                                try {
                                    let userinfo = JSON.parse(ret);
                                    if (!_this.isEmpty(userinfo.user_id)) {
                                        suLogin(userinfo);
                                    } else {
                                        alert('该活动需要登录后才能参加');
                                        openlogin();
                                    }
                                } catch (e) {
                                    alert('该活动需要登录后才能参加');
                                    openlogin();
                                }

                                function openlogin() {
                                    COVERAPP.Method.OpenLogin({
                                        callback (ret) {
                                            let userinfo = JSON.parse(ret);
                                            if (!isEmpty(userinfo.user_id)) {
                                                suLogin(userinfo);
                                            } else {
                                                alert('该活动需要登录后才能参加');
                                            }
                                        }
                                    });
                                }

                            }
                        });

                        function suLogin(info) {
                            let userinfo = {
                                origin: 'tc',
                                token: info.user_id,
                                headimgurl: info.avatar,
                                nickname: info.nickname,
                                sex: info.gender,
                                age: info.age,
                                mobile: info.mobile,
                                register_way: info.register_way
                            }
                            sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo));
                            callback(userinfo);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                }, 300);
                return false;
            }
            callback({
                origin: 'none'
            });

        }
    },

    //重置APP用户信息
    resetUserData(info) {
        var userinfo = {
            origin: 'tc',
            token: info.user_id,
            headimgurl: info.avatar,
            nickname: info.nickname,
            sex: info.gender,
            age: info.age,
            mobile: info.mobile,
            register_way: info.register_way
        }
        return JSON.parse(JSON.stringify(userinfo));
    },

    // ajax 请求 @depend zepto
    ajax (url, data) {
        let self = this;
        let deviceid = self.isEmpty(Config.ApiToken) == false ? Config.ApiToken : Math.random().toString(36).substr(2, 15);
        let timestamp = Config.timestamp;
        let sign = md5(Config.Api_sign_root + data.timestamp).toUpperCase();
        return new Promise((resolve, reject) => {
            axios.post(Config.HTTP_URL + url + '/?deviceid=' + deviceid + '&timestamp=' + timestamp + '&sign=' + sign, 'data=' + JSON.stringify(data)).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        })
        
    },

    ajaxPost(url, data) {
        return new Promise((resolve, reject) => {
            axios.post(Config.HTTP_URL + url, data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        })
    },

    ajaxGet(url, data) {
        return new Promise((resolve, reject) => {
            axios.get(
                Config.HTTP_URL + url,
                {
                    params: JSON.parse(JSON.stringify(data))
                }
            ).then((res)=> {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        })
    },

    // 排序
    asciiSort (args) {
        let keys = Object.keys(args);
        keys = keys.sort();
        let newArgs = {};
        keys.forEach(function (key) {
            newArgs[key] = args[key];
        });
        let string = '';
        for (let k in newArgs) {
            string += '&' + k + '=' + newArgs[k];
        }
        string = string.substr(1);
        return string;
    },

    /**
     * 请求接口
     * url: 请求地址
     * data: 报文
     * metods: 方法，任意值后会是，POST。默认是：jsonp
     * isEnCdoe: 是否加密，true-加密
     */
    $request (url, data, metods, isEnCdoe) {
        /* let nonceStr = Math.random().toString(36).substr(2, 10);
        let timestamp = new Date().getTime();
        let info = JSON.parse(JSON.stringify(data));
        info.nonceStr = nonceStr;
        info.timestamp = timestamp;
        delete info.sign;

        if(COVERAPP.Attribute.isApp()){
            info.deviceid = COVERAPP.Attribute.deviceId();
        }

        let str = this.asciiSort(info);
        let sign = md5(str).toUpperCase();
        info.sign = sign; */
        if (isEnCdoe) {
            let enCodeData = algo(JSON.stringify(info));
            info = {
                enCodeData: enCodeData
            }
        }

        if (metods === 'get') {
            return new Promise((resolve, reject) => {
                axios.get(Config.ACTIVITY_URL + url, {
                  params: data,
                }).then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
            })
        }

        if (metods === 'put') {
            return new Promise((resolve, reject) => {
                axios.put(Config.ACTIVITY_URL + url, data).then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
            })
        }

        if (metods) {
            return new Promise((resolve, reject) => {
                axios.post(Config.ACTIVITY_URL + url, data).then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
            })
        }
        return new Promise((resolve, reject) => {
            axios({
                url: Config.ACTIVITY_URL + url + '?' + qs.stringify(info),
                adapter: axiosJsonp
            }).then((res) => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        })
    },

    $get(url, data) {
        return new Promise((resolve, reject) => {
            axios.get(
                Config.ACTIVITY_URL + url,
                {
                    params: JSON.parse(JSON.stringify(data))
                }
            ).then((res)=> {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        })
    },

    $post(url, data) {
        return new Promise((resolve, reject) => {
            axios.post(
                Config.ACTIVITY_URL + url, 
                data
            ).then((res) => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        })
    },

    // 在评论内容中渲染自定义表情
    renderReplyContent (str) {
        let cdn_url_base = 'https://wapcdn.thecover.cn/wap/1.6.0/img/';
        let key_arr = [{
            '困': cdn_url_base + 'emotion_kun.png'
        }, {
            '笑cry': cdn_url_base + 'emotion_xiaocry.png'
        }, {
            '卖萌': cdn_url_base + 'emotion_maimeng.png'
        }, {
            '发怒': cdn_url_base + 'emotion_fanu.png'
        }, {
            '可怜': cdn_url_base + 'emotion_kelian.png'
        }, {
            '呕吐': cdn_url_base + 'emotion_outu.png'
        }, {
            '坏笑': cdn_url_base + 'emotion_huaixiao.png'
        }, {
            '大笑': cdn_url_base + 'emotion_daxiao.png'
        }, {
            '害羞': cdn_url_base + 'emotion_haixiu.png'
        }, {
            '尴尬': cdn_url_base + 'emotion_ganga.png'
        }, {
            '得意': cdn_url_base + 'emotion_deyi.png'
        }, {
            '微笑': cdn_url_base + 'emotion_weixiao.png'
        }, {
            '流汗': cdn_url_base + 'emotion_liuhan.png'
        }, {
            '流泪': cdn_url_base + 'emotion_liulei.png'
        }, {
            '爱心': cdn_url_base + 'emotion_aixin.png'
        }, {
            '生气': cdn_url_base + 'emotion_shengqi.png'
        }, {
            '白眼': cdn_url_base + 'emotion_baiyan.png'
        }, {
            '耍酷': cdn_url_base + 'emotion_shuaku.png'
        }, {
            '花痴': cdn_url_base + 'emotion_huachi.png'
        }, {
            '鼻血': cdn_url_base + 'emotion_bixue.png'
        }];
        for (let i = 0; i < key_arr.length; i++) {
            str = str.replace((new RegExp('\\[' + Object.keys(key_arr[i])[0] + '\\]', 'gi')), ('<img src="' + key_arr[i][Object.keys(key_arr[i])[0]] + '" class="custom-emoji-in-replys">'));
        }
        return str;
    },

    // 是否是邮箱
    isEmail (str) {
        return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str);
    },

    // 是否是身份证号
    isCard (cardNo) {
        let info = {
            isTrue: false, // 身份证号是否有效。默认为 false
            year: null, // 出生年。默认为null
            month: null, // 出生月。默认为null
            day: null, // 出生日。默认为null
            isMale: false, // 是否为男性。默认false
            isFemale: false // 是否为女性。默认false
        };
        if (!cardNo || (15 != cardNo.length && 18 != cardNo.length)) {
            info.isTrue = false;
            return info;
        }
        if (15 == cardNo.length) {
            let year = cardNo.substring(6, 8);
            let month = cardNo.substring(8, 10);
            let day = cardNo.substring(10, 12);
            let p = cardNo.substring(14, 15); // 性别位
            let birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 对于老身份证中的年龄则不需考虑千年虫问题而使用getYear()方法
            if (birthday.getYear() != parseFloat(year) ||
                birthday.getMonth() != parseFloat(month) - 1 ||
                birthday.getDate() != parseFloat(day)) {
                info.isTrue = false;
            } else {
                info.isTrue = true;
                info.year = birthday.getFullYear();
                info.month = birthday.getMonth() + 1;
                info.day = birthday.getDate();
                if (p % 2 == 0) {
                    info.isFemale = true;
                    info.isMale = false;
                } else {
                    info.isFemale = false;
                    info.isMale = true;
                }
            }
            return info;
        }
        if (18 == cardNo.length) {
            let year = cardNo.substring(6, 10);
            let month = cardNo.substring(10, 12);
            let day = cardNo.substring(12, 14);
            let p = cardNo.substring(14, 17);
            let birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 这里用getFullYear()获取年份，避免千年虫问题
            if (birthday.getFullYear() != parseFloat(year) ||
                birthday.getMonth() != parseFloat(month) - 1 ||
                birthday.getDate() != parseFloat(day)) {
                info.isTrue = false;
                return info;
            }
            let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
            let Y = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
            // 验证校验位
            let sum = 0; // 声明加权求和变量
            let _cardNo = cardNo.split("");
            if (_cardNo[17].toLowerCase() == 'x') {
                _cardNo[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
            }
            for (let i = 0; i < 17; i++) {
                sum += Wi[i] * _cardNo[i]; // 加权求和
            }
            let i = sum % 11; // 得到验证码所位置
            if (_cardNo[17] != Y[i]) {
                return info.isTrue = false;
            }
            info.isTrue = true;
            info.year = birthday.getFullYear();
            info.month = birthday.getMonth() + 1;
            info.day = birthday.getDate();
            if (p % 2 == 0) {
                info.isFemale = true;
                info.isMale = false;
            } else {
                info.isFemale = false;
                info.isMale = true;
            }
            return info;
        }
        return info;
    },

    // 过滤数据
    safehtml (str) {
        return str.replace(/<\/h*[^>]*>/gi, '</p>') // 去掉H*开始标签
            .replace(/<h[^>]*>/gi, '<p>') // 去掉H*结束标签
            .replace(/<a[^>]*>/gi, '<a>') // 去掉a标签中的链接等数据
            .replace(/style="[\s\S]*?"/gi, '') // 去掉style
            .replace(/<script[^>]*>[\s\S]*?<\/[^>]*script>/gi, ''); // 去掉javascript
    },

    /*
        * 点击量、分享量记录到新闻稿
        * id 新闻的newsis
        * at 活动点击类型。1：浏览，2：分享
        */
    recordAct (id, at) {
        let _this = this;
        this.ajax(Config.apiurl.recordActivityClickRate, {
            news_id: id,
            action_type: at || 1,
        });
    },

    /*
        * 发送系统消息
        * opt 参数  
        *   user_id  用户的唯一标示
        *   mobile  手机号
        *   content  内容
        *   url  链接
        * callback 回调
        */
    sendMsg (opt, callback) {
        let _this = this;
        this.ajax(Config.apiurl.setMessageInfo, opt).then(res => {
            callback(res);
        });
    },

    // 加载一张图片
    onloadImg (url, cbk) {
        let img = new Image();
        img.src = url;
        img.onload = function () {
            if (typeof cbk == 'function') {
                cbk();
            }
        };
    },

    // 埋点统计
    track (aid, event, label) {
        return;
        let url = Config.ACTIVITY_URL + '/log/track?aid=' + aid + '&ev=' + event + '&la=' + label + "&dd=" + getDid();
        // 读取用户信息
        let userinfo = sessionStorage.getItem('COVER_USERINFO') || '';
        if (userinfo) {
            url = url + '&ui=' + userinfo
        }

        this.onloadImg(url);

        function getDid() {
            let ua = navigator.userAgent;
            if (/TheCover/i.test(ua)) {
                return 'app-' + ua.split('(TheCover_')[1].split('_')[2].split(')')[0];
            }
            let did = localStorage.getItem('COVER_APM_DID');
            if (!did) {
                did = 'other-' + new Date().getTime().toString(36) + '-' + Math.random().toString(36).substr(2, 8);
                localStorage.setItem('COVER_APM_DID', did);
            }
            return did;
        }
    },

    isWapHidden () {
        document.addEventListener("qbrowserVisibilityChange", (e)=> {
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("visibilitychange", false, false);
            evt.hidden = e.hidden;
            document.dispatchEvent(evt);
        }, true);

        document.addEventListener("visibilitychange", (e)=> {
            e.hidden = e.hidden === undefined ? document.hidden : e.hidden;
        }, true);

        document.addEventListener("visibilitychange",(e)=> {
            if (e.hidden) {
                // 网页被挂起
                this.wapHidden = true;
            } else {             
                this.wapHidden = false;
            }
        });
    },

    // APP打开链接
    downloadApp(aid, flag, id) {
        let downHref = '';
        if (COVERAPP.Attribute.isAndroid()) {            
            if (COVERAPP.Attribute.isWeixin()) {
                downHref = flag ? `${Config.WEIXIN_APP_SCHEME_URL}/news?id=${id}&flag=${flag}&version=${new Date().getTime()}` : `${Config.WEIXIN_APP_SCHEME_URL}/open`;
                COVER.onloadImg(downHref);
            } else {
                downHref = flag ? `${Config.APP_SCHEME_URL}/news?id=${id}&flag=${flag}&version=${new Date().getTime()}` : `${Config.APP_SCHEME_URL}/open`;
                window.location.href = downHref;
            }
            setTimeout(() => {
                if (!this.wapHidden) {
                    if (COVERAPP.Attribute.isWeixin()) {
                        window.location.href = Config.WEXIN_APP_DOWNLOAD_ADDRESS;
                    } else {
                        window.location.href = download_url;
                    }
                }
            }, 300)
        } else {
            downHref = flag ? `${Config.UNIVERSALLINK}?version=${new Date().getTime()}&to=news&id=${id}&flag=${flag}` : `${Config.UNIVERSALLINK}?version=${new Date().getTime()}`;
            window.location.href = downHref
        }

        COVER.$request('/activity/getdata', {
            aid: aid,
            evt: 'download'
        });
    },

    $getScript(url) {
        return new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.type = "text/javascript";
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState == "loaded" || script.readyState == "complete") {
                        script.onreadystatechange = null;
                        resolve();
                    }
                }
            } else {
                script.onload = function () {
                    resolve();
                }
            }
            script.src = url;
            document.body.appendChild(script);
        })
    },

    // 第三方api
    openapi: {

        // 微信相关
        weixin: {
            // 微信配置
            wx_conf (obj, callback) {

                let self = this;
                let url = window.location.href.split('#')[0];
                let data = {
                    url: encodeURIComponent(url),
                    version: "1.0.0"
                };
                COVER.ajax(Config.apiurl.weixingetConf, data).then(res => {
                    let D = res.data.data;
                    wx.config({
                        debug: false,
                        appId: D.appId,
                        timestamp: D.timestamp,
                        nonceStr: D.nonceStr,
                        signature: D.signature,
                        jsApiList: [
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone',
                            'chooseImage',
                            'previewImage',
                            'uploadImage',
                            'downloadImage',
                            'hideOptionMenu'
                        ]
                    });

                    self[callback](obj);
                });


            },

            // 微信分享
            wx_share (obj) {
                this.wx_conf(obj, 'wx_onshare');
            },

            // 打开相册
            wx_chooseImage () {
                this.wx_conf('', 'wx_onchooseImage');
            },

            // 隐藏右上角菜单
            wx_hideOptionMenu () {
                this.wx_conf('', 'wx_onhideOptionMenu');
            },

            // 显示右上角菜单
            wx_showOptionMenu () {
                this.wx_conf('', 'wx_onshowOptionMenu');
            },

            // previewImage
            wx_previewImage (obj) {
                this.wx_conf(obj, 'wx_onpreviewImage');
            },

            wx_onpreviewImage (obj) {
                wx.previewImage(obj);
            },

            wx_onshowOptionMenu () {
                wx.showOptionMenu();
            },

            wx_onhideOptionMenu () {
                wx.hideOptionMenu();
            },

            wx_onchooseImage () {
                wx.ready(function () {
                    wx.chooseImage({
                        count: 1, // 默认9
                        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                        success (res) {
                            let localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                            /*COVER.skip('main.html?localIds='+localIds);*/

                        }
                    });
                });
            },

            wx_onshare (obj) {
                wx.ready(function () {

                    // 分享到朋友圈
                    wx.onMenuShareTimeline(obj);

                    // 分享给朋友
                    wx.onMenuShareAppMessage(obj);

                    // 分享到QQ
                    wx.onMenuShareQQ(obj);

                    // 分享到腾讯微博
                    wx.onMenuShareWeibo(obj);

                    // 分享到QQ空间
                    wx.onMenuShareQZone(obj);


                });

            },

            // 登录
            wx_login (callback) {
                COVER.skip('passport.html', {
                    url: window.location.href
                });
            }

        },

        // 手Q相关
        mqq: {
            // 分享
            setShareInfo (obj) {
                obj.image_url = obj.imgUrl;
                obj.share_url = obj.link;
                obj.callback = obj.success;
                mqq.setShareInfo(obj);
            }
        },

        // QQ空间相关
        qzone: {
            share (obj) {
                //给QQ好友分享内容
                mqq.invoke("share", "toQQ", obj, obj.success);

                //分享内容到QQ空间
                mqq.invoke("share", "toQQ", obj, obj.success);

            }
        },
    }
};
export default COVER = COVER;
